import { jsx } from "react/jsx-runtime";
import { range } from "lodash/fp";
import { addDays, startOfWeek, format } from "date-fns/fp";
import { CalendarDays, CalendarDay } from "./calendar-weekdays.styles.es.js";
const daysOfWeek = range(0, 7).map(
  (day) => addDays(day, startOfWeek(/* @__PURE__ */ new Date()))
);
const CalendarWeekdays = () => /* @__PURE__ */ jsx(CalendarDays, { children: daysOfWeek.map((date) => /* @__PURE__ */ jsx(CalendarDay, { "aria-label": format("EEEE", date), children: format("EEEEEE", date) }, date.getDay())) });
export {
  CalendarWeekdays
};
